import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list-add",
  "use": "icon-list-add-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-list-add\">\n\t<path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.5 6.5h12m-12 4h12m-12 4h7m2 0h4zm2 2v-4z\" stroke-width=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol